import React from 'react';
import {
  MessageCircle,
  ClipboardList,
  Activity,
  Users,
  Bell,
  LineChart,
  Shield
} from 'lucide-react';

import HeroSection from '@/components/how-it-works/HeroSection';
import JourneyTimeline from '@/components/how-it-works/JourneyTimeline';
import BenefitsSection from '@/components/how-it-works/BenefitsSection';
import IntegrationSection from '@/components/how-it-works/IntegrationSection';
import CTASection from '@/components/how-it-works/CTASection';

const journeySteps = [
  {
    icon: <ClipboardList className="w-24 h-24 text-blue-500 opacity-50" />,
    title: "Initial Setup",
    description: "Quick and easy onboarding process",
    features: [
      "Choose your preferred interaction method",
      "Set up your recovery schedule",
      "Connect with your care team"
    ]
  },
  {
    icon: <MessageCircle className="w-24 h-24 text-blue-500 opacity-50" />,
    title: "Daily Check-ins",
    description: "Regular monitoring of your progress",
    features: [
      "Symptom assessment",
      "Medication reminders",
      "Progress tracking"
    ]
  },
  {
    icon: <Activity className="w-24 h-24 text-blue-500 opacity-50" />,
    title: "Continuous Monitoring",
    description: "Real-time health tracking",
    features: [
      "Vital signs monitoring",
      "Recovery milestone tracking",
      "Early warning detection"
    ]
  },
  {
    icon: <Users className="w-24 h-24 text-blue-500 opacity-50" />,
    title: "Care Team Coordination",
    description: "Seamless communication with healthcare providers",
    features: [
      "Instant alerts to care team",
      "Progress reports sharing",
      "Appointment scheduling"
    ]
  }
];

const supportFeatures = [
  {
    icon: <Bell className="w-6 h-6 text-blue-600" />,
    title: "Smart Alerts",
    description: "Receive timely notifications about important updates and required actions"
  },
  {
    icon: <LineChart className="w-6 h-6 text-blue-600" />,
    title: "Progress Tracking",
    description: "Visual insights into your recovery journey and milestone achievements"
  },
  {
    icon: <Shield className="w-6 h-6 text-blue-600" />,
    title: "Proactive Care",
    description: "Early detection and prevention of potential complications"
  }
];

const integrations = [
  {
    title: "Electronic Health Records",
    description: "Seamlessly connects with major EHR systems"
  },
  {
    title: "Practice Management",
    description: "Integrates with your existing workflow tools"
  },
  {
    title: "Patient Portals",
    description: "Works alongside your current patient engagement platforms"
  }
];

const HowItWorksPage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <JourneyTimeline steps={journeySteps} />
      <BenefitsSection features={supportFeatures} />
      <IntegrationSection integrations={integrations} />
      <CTASection />
    </div>
  );
};

export default HowItWorksPage;